var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"bg-white",attrs:{"src":require("@/assets/images/logo/logo5-blue-white-gold-fill-sm.png"),"alt":"NYSSMA","height":"50"}})}
var staticRenderFns = []

export { render, staticRenderFns }